import classNames from 'classnames';
import { Heading } from 'components/1-atoms/Heading';
import styles from './ReadMore.module.scss';

export interface ReadMoreProps {
	className?: string;
	heading: string;
	links: React.ReactElement[];
}

export const ReadMore: React.FC<ReadMoreProps> = ({ className, heading, links }) => {
	return (
		<div className={classNames(styles.ReadMore, className)}>
			<Heading className={styles.ReadMore_heading} headingLevel="h2" style="xs">
				{heading}
			</Heading>
			<ul className={styles.ReadMore_links}>
				{links.map((link, i) => {
					return <li key={i}>{link}</li>;
				})}
			</ul>
		</div>
	);
};
